// extracted by mini-css-extract-plugin
export default {"eyebrow":"Eyebrow-module--eyebrow--uvwzp","colorWhite":"Eyebrow-module--colorWhite--71xSJ","colorYellow":"Eyebrow-module--colorYellow--cFcdc"};